import PosthogService from '~/services/posthog/PosthogService';

export interface IPermCloseJobFeedbackSubmittedPayload {
  userId?: string;
  postingId?: string;
  positiveFeedback?: string[];
  negativeFeedback?: string[];
  otherFeedback: string;
  hasHires: boolean;
}

/**
 * Fires when an office submits feedback while closing a permanent job.
 * Event: office:perm:close_job_feedback_submitted
 *
 * The `*_count` properties are derived from the feedback arrays here so callers
 * pass the raw arrays only once.
 */
export function firePermCloseJobFeedbackSubmitted(
  payload: IPermCloseJobFeedbackSubmittedPayload,
): void {
  PosthogService.getInstance().track('office:perm:close_job_feedback_submitted', {
    user_id: payload.userId,
    posting_id: payload.postingId,
    positive_feedback: payload.positiveFeedback,
    positive_feedback_count: payload.positiveFeedback?.length || 0,
    negative_feedback: payload.negativeFeedback,
    negative_feedback_count: payload.negativeFeedback?.length || 0,
    other_feedback: payload.otherFeedback,
    has_hires: payload.hasHires,
  });
}
